import { render, staticRenderFns } from "./BestShopping.vue?vue&type=template&id=366392dd&scoped=true"
import script from "./BestShopping.vue?vue&type=script&lang=js"
export * from "./BestShopping.vue?vue&type=script&lang=js"
import style0 from "./BestShopping.vue?vue&type=style&index=0&id=366392dd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "366392dd",
  null
  
)

export default component.exports